import React from "react";
import BaseComponent from "@js/components/base_component.jsx";
import {
  ceScreenEditorSave,
  ceScreenEditorCancel,
} from "@js/actions/studio/campaign_content_section/screen_editor.js";
import { screenConnect } from "@screen";
import update from "immutability-helper";

class EditorHugeRTE extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { loading: true };
  }

  componentDidMount() {
    const config = this.hugerteConfig();
    hugerte.init(config);
  }

  componentWillUnmount() {
    if (this.hugerte) {
      this.hugerte.remove();
      this.hugerte = null;
    }
    // We need to clear the subscription to the connector
    // Otherwise, a user could open a new editor and click cancel before
    // the subscription is overwritten, causing reference errors.
    let nullFunc = () => {};
    this.props.connector.subscribe(nullFunc);
  }

  render() {
    // We use display: none for the loader because once loading is done, we
    // want it to be completely out of the document flow.
    let loadingStyle = this.state.loading ? {} : { display: "none" };

    // We use visibility: none here so that the element still has size during
    // its initialization.
    let editorStyle = this.state.loading ? { visibility: "none" } : {};

    return (
      <React.Fragment>
        <div style={{ ...loadingStyle }}>
          {t("phrases.react_content.loading_hugerte")}
        </div>
        <textarea
          id="content-editor-hugerte-container"
          defaultValue={
            this.props.format === "text" ? this.props.text : this.props.html
          }
          style={{ width: "100%", height: "100%", ...editorStyle }}
        />
      </React.Fragment>
    );
  }

  hugerteConfig() {
    let textarea = document.getElementById("content-editor-hugerte-container");

    let options = this.props.library.hugerte_config.options;

    // Remove the "fullscreen" plugin when we're in this editor. It's already
    // fullscreen and it causes a glitch.

    const fullscreenPluginIndex = options.plugins.indexOf("fullscreen");

    if ( fullscreenPluginIndex >= 0 ) {
      options = update(options, {
        plugins: {
          $splice: [[fullscreenPluginIndex, 1]],
        },
      });
    }

    // Set options we need for its size.

    options = update(options, {
      $merge: {
        selector: "#content-editor-hugerte-container",
        init_instance_callback: this.initInstanceCallback,
        width: textarea.clientWidth,
        height: textarea.clientHeight,
      },
    });

    return options;
  }

  onConnectorEvent(e) {
    switch (e.type) {
      case "save": {
        const value = this.hugerte.getContent();

        if (this.props.format === "text") {
          this.props.dispatch(ceScreenEditorSave(null, null, value));
        } else {
          this.props.dispatch(ceScreenEditorSave(null, value, null));
        }

        break;
      }

      case "insert": {
        this.hugerte.insertContent(e.value);

        break;
      }

      case "cancel": {
        // Note: this.props.html will be blank on fresh contents, and will not match with
        // this.hugerte.getContent's return value, since that function adds <html> boilerplate
        // tags. For this reason, you cannot make a fresh HugeRTE content "clean" again.
        let defaultValue =
          this.props.format === "text" ? this.props.text : this.props.html;
        let hasChanges =
          this.hugerte.isDirty() && this.hugerte.getContent() !== defaultValue;
        this.props.dispatch(ceScreenEditorCancel(hasChanges));
        break;
      }
    }
  }

  initInstanceCallback(inst) {
    this.hugerte = inst;
    this.props.connector.subscribe(this.onConnectorEvent);
    this.setState({ loading: false });
  }
}

export default screenConnect(EditorHugeRTE);
